import { Component, OnInit } from '@angular/core';
import { AllAppVersionInfo, VersionInfo } from './about.models';
import { AboutService } from './about.service';

declare const saveAs: (blob: Blob, fileName: string) => void;

@Component({
    selector: 'about',
    templateUrl: './about.component.html',
    styleUrls: ['./about.component.scss'],
    standalone: false
})
export class AboutComponent implements OnInit {
    constructor(
        private aboutService: AboutService
    ) {
    }

    loading: boolean;
    allAppVersionInfo: AllAppVersionInfo;
    uiVersionInfo: VersionInfo;
    reportVersionInfo: VersionInfo;
    emailButtonDisabled: boolean;


    async ngOnInit() {
        this.loading = true;
        try {
            this.reportVersionInfo = null;
            // We should probably use promise.all to get these in parallel
            this.allAppVersionInfo = await this.aboutService.getAllAppVersionInfo();
            this.uiVersionInfo = await this.aboutService.GetUIVersionInfo();
        } finally {
            this.loading = false;
        }
    }

    async getJSReportVersionInfo() {
        this.loading = true;

        try {
            this.reportVersionInfo = await this.aboutService.getJSReportVersionInfo();
        } finally {
            this.loading = false;
        }
    }
}
